import api from "../utils/API";
import { getUserData } from "../utils/FunctionHelpers";

const getUserNotifications = () => {
  return api.get(`/candidatmanagement/notifications/list?user=${getUserData()?.uuid}`);
};

const updateSeenNotification = (notificationUuid) => {
  return api.post(`/candidatmanagement/notifications/seen`, { notificationUuid });
};

const deleteNotification = (notificationUuid) => {
  return api.delete(`/candidatmanagement/notifications/delete/${notificationUuid}`);
};

export { getUserNotifications, updateSeenNotification, deleteNotification };